import { createFileRoute, notFound } from "@tanstack/react-router";
import { getPage } from "@/content/pages";
import { MarkdownPage } from "@/components/MarkdownPage";
import ServiceHostingImage from "@/assets/service-hosting.jpg";

const PAGE_KEY = "/hosting";

export const Route = createFileRoute("/hosting")({
  loader: () => {
    const page = getPage(PAGE_KEY);
    if (!page) throw notFound();
    return page;
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? [
          { title: loaderData.title },
          { name: "description", content: loaderData.description },
          { property: "og:title", content: loaderData.title },
          { property: "og:description", content: loaderData.description },
      { property: "og:url", content: "https://www.phil-carr.co.uk/hosting" },
        ]
      : [],
    links: [{ rel: "canonical", href: "https://www.phil-carr.co.uk/hosting" }],
  }),
  notFoundComponent: () => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-4xl">Page not found</h1>
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-3xl">Something went wrong</h1>
      <p className="mt-3 text-muted-foreground">{error.message}</p>
    </div>
  ),
  component: Page,
});

function Page() {
  const page = Route.useLoaderData();
  return (
    <MarkdownPage body={page.body} pageContext={page.title} heroImage={{ src: ServiceHostingImage, alt: 'Server room with illuminated racks providing reliable hosting' }} relatedSlugs={["mobile-and-core-web-vitals-in-2023", "user-experience-takes-centre-stage-core-web-vitals-2-0-and-beyond", "why-seo-starts-with-your-website-and-always-will"]} />
  );
}
